import { render, staticRenderFns } from "./LegalDocShell.vue?vue&type=template&id=f8bfd318&scoped=true&"
import script from "./LegalDocShell.vue?vue&type=script&lang=js&"
export * from "./LegalDocShell.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocShell.vue?vue&type=style&index=0&id=f8bfd318&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bfd318",
  null
  
)

export default component.exports